let offset = 0

export function setOffsetFromHeaderDate(headerDate) {
  if (!headerDate) return

  const doServidor = Date.parse(headerDate)
  if (Number.isNaN(doServidor)) return

  offset = Date.now() - doServidor
}

export function serverNow() {
  return Date.now() - offset
}

export function clockOffsetSeconds() {
  return Math.round(offset / 1000)
}
